<div #sessionpopup class="bl-padding-top--40 bl-padding-bottom--48 congrats-dialog bl-padding-x--24">
  <div class="bl-max-width--100 bl-display--block bl-margin-x--auto bl-text-align--center">
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="40" fill="#FFEBDE" />
      <path
        d="M53.9358 62C53.9736 61.3403 54 60.6752 54 60C54 51.1095 50.6373 43.4696 45.8076 40C50.6373 36.5304 54 28.8905 54 20C54 19.3248 53.9736 18.6597 53.9358 18H26.0642C26.0264 18.6597 26 19.3248 26 20C26 28.8905 29.3627 36.5304 34.1924 40C29.3627 43.4696 26 51.1095 26 60C26 60.6752 26.0264 61.3403 26.0642 62H53.9358Z"
        fill="#BADEFC"
      />
      <path
        d="M58 17H22C21.4473 17 21 17.4473 21 18V20C21 20.5527 21.4473 21 22 21H58C58.5527 21 59 20.5527 59 20V18C59 17.4473 58.5527 17 58 17Z"
        fill="#A67C52"
      />
      <path
        d="M58 59H22C21.4473 59 21 59.4473 21 60V62C21 62.5527 21.4473 63 22 63H58C58.5527 63 59 62.5527 59 62V60C59 59.4473 58.5527 59 58 59Z"
        fill="#A67C52"
      />
      <path
        d="M33.2446 33C34.1824 34.5701 35.288 35.8614 36.5263 36.751L39.9999 39.2471L43.4736 36.751C44.7119 35.8614 45.8175 34.5701 46.7552 33H33.2446Z"
        fill="#EA9860"
      />
      <path d="M30 57H50C49 53 42.9375 46 40 46C36.9375 46 30.9375 53.0625 30 57Z" fill="#EA9860" />
    </svg>
  </div>
  <h1 class="bl-font-weight--900 bl-font-size--22 bl-text-align--center">
    {{ 'userSession/yourSessionExpire' | dictionary }}
  </h1>

  <p class="bl-font-weight--900 bl-font-size--22 bl-text-align--center">{{ minutes | mask : '00' }}:{{ seconds | mask : '00' }}</p>
  <div class="bl-text-align--center">
    <button
      (click)="logOut()"
      id="cancel"
      #cancel
      (keydown.tab)="onTabKeyEvent($event)"
      class="bl-button bl-button-reverse bl-margin-right--24"
    >
      {{ 'userSession/signOut' | dictionary }}
    </button>
    <button
      #refresh
      (click)="continueSession()"
      id="refresh"
      (keydown.tab)="onTabKeyEvent($event)"
      class="bl-display--inline-block bl-font-weight--600 bl-button"
    >
      {{ 'userSession/continue' | dictionary }}
    </button>
  </div>
</div>
